import { colors } from "../utils/colors";

export function PrimaryButton({ 
  children, 
  onClick, 
  type = "button", 
  className = "",
  disabled = false,
  loading = false
}) {
  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled || loading}
      className={className}
      style={{ 
        borderRadius: '8px',
        padding: '12px 16px',
        fontWeight: '600',
        boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
        transition: 'all 0.2s ease',
        cursor: disabled || loading ? 'not-allowed' : 'pointer',
        opacity: disabled || loading ? 0.7 : 1,
        border: 'none',
        backgroundColor: colors.primary || '#2563eb',
        color: 'white'
      }}
      onMouseDown={(e) => {
        if (!disabled && !loading) {
          e.target.style.transform = 'scale(0.99)';
        }
      }}
      onMouseUp={(e) => {
        if (!disabled && !loading) {
          e.target.style.transform = 'scale(1)';
        }
      }}
      onMouseLeave={(e) => {
        if (!disabled && !loading) {
          e.target.style.transform = 'scale(1)';
        }
      }}
    >
      {loading ? 'Carregando...' : children}
    </button>
  );
}

// Button secundário/ghost
export function GhostButton({ 
  children, 
  onClick, 
  className = "",
  disabled = false
}) {
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={className}
      style={{ 
        borderRadius: '8px',
        padding: '12px 16px',
        fontWeight: '600',
        border: `1px solid ${colors.accent || '#d1d5db'}`,
        backgroundColor: 'transparent',
        color: colors.text || '#374151',
        transition: 'all 0.2s ease',
        cursor: disabled ? 'not-allowed' : 'pointer',
        opacity: disabled ? 0.7 : 1
      }}
      onMouseEnter={(e) => {
        if (!disabled) {
          e.target.style.backgroundColor = colors.accent ? `${colors.accent}20` : 'rgba(209, 213, 219, 0.1)';
        }
      }}
      onMouseLeave={(e) => {
        if (!disabled) {
          e.target.style.backgroundColor = 'transparent';
        }
      }}
    >
      {children}
    </button>
  );
}